import { EctRow } from "./ectRow";

export class EctRows {
  sheetID: number
  marketID: number
  peakTCHour: number
  peakHourlyTCDaytime:number
  ectRows: EctRow[] = [];
}
